import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../utils'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'
import { getDownloadFilename, triggerBlobDownload } from '../utils/download'

export default function BigQueryExporterFile() {
	SetTitle('BigQuery Exporter')
	const params = useParams()

	useEffect(() => {
		downloadData()
	}, [])

	const downloadData = () => {
		if (params?.id) {
			api.get('get-bigquery-exporter/' + params.id, { responseType: 'blob' })
				.then((response) => {
					const contentDisposition = response.headers['content-disposition'];
					const fileName = getDownloadFilename(contentDisposition, 'export.csv')
					triggerBlobDownload(response.data, fileName)
					setTimeout(() => {
						window.location.href = '/bigquery-exporter'
					}, 5000)
				})
				.catch((error) => {
					console.error("Download failed:", error);
					// Handle error appropriately, maybe show a message to the user
					setTimeout(() => {
						window.location.href = '/bigquery-exporter'
					}, 5000)
				});
		}
		else {
			setTimeout(() => {
				window.location.href = '/bigquery-exporter'
			}, 1000)
		}
	}

	return (
		<Header
			iconClass="ni ni-folder-17 text-white"
			title="BigQuery Exporter"
			description="Download in corso..."
		/>
	)
}
